import { UserStore } from './user/user-store.state';

export const store = [
  UserStore
];
